module.exports = __webpack_public_path__ + "img/wx.7f061f82.png";